import React,{useState,useEffect} from 'react';
import axios from 'axios';
import product1 from "../images/Product1.jpg";
import product2 from "../images/Product2.jpg";
import product3 from "../images/Product3.jpg";
import product4 from "../images/Product4.jpg";
import product5 from "../images/Product5.jpg"
import { useDispatch } from 'react-redux';
import { addtocart,increaseqty,decreaseqty } from '../Slice';
import { useSelector } from 'react-redux';

const Home = () => {
    const[products,setProducts] = useState([])
    const[error,setError] = useState("")
    const[loading,setLoading] = useState(false)
    const a = [product1,product2,product3,product4,product5]
    const dispatch = useDispatch()
    const select = useSelector(state=>state.products.items)

    useEffect(()=>{
        const fetchproducts = async ()=>{
            try{
                setLoading(true)

                const res = await axios.get("https://dummyjson.com/products?limit=5")
                const data = res.data.products;
                setProducts(data)
               
            }catch(error){
                setError("Error in fetching products:",error)
            }finally{
                setLoading(false)
            }
        }

        fetchproducts();
    },[])
     console.log(products)
     if(loading) return <p>Loading....</p>
     if(error) return <p>Error in Product Loading</p>
    
  return (
    <div className='products'>
        {products.map((b,k)=>{
            const images = a[ k % a.length ];
            const cartqtynumber = select.find((item)=>item.id === b.id);
            const qty = cartqtynumber ? cartqtynumber.quantity : 0
            return(
            <div key={k} className='product-card'>
                <div className='product-wrapper'>
                    <img src={images} alt={b.title}/>
                </div>
                <div className='content'>
                    <h3>{b.title}</h3>
                    <p>Price:$.{b.price}</p>
                    <button className='btn' onClick={()=>dispatch(addtocart({title: b.title,price: b.price, id: b.id, images}))}>Add to Cart</button>
                    <div className='qty'>
                        <button onClick={()=>dispatch(increaseqty({ id:b.id }))}>+</button>
                            <span style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>{qty}</span>

                        <button onClick={()=>dispatch(decreaseqty({ id:b.id }))}>-</button>
                    </div>
                </div>
            </div>
            )
})}
    </div>
  )
}

export default Home